import React from "react";
import Group53 from "../../assets/Services_1.webp";
import Group51 from "../../assets/Services_2.webp";
import Group52 from "../../assets/Services_3.webp";
import Group54 from "../../assets/Services_4.webp";
import Grid from "../../assets/Grid.png";

const OurService = () => {
  return (
    <div className="py-5" style={{ backgroundImage: `url(${Grid})` }}>
      <div className="mx-auto w-full max-w-7xl px-4">
        <h2
          className="text-center font-sf lg:text-[28px] md:text-[28px] text-[24px] font-bold mb-5 text-[#212529]"
         
        >
          Our Services and Solutions
        </h2>

        <div className="flex flex-wrap items-center gap-8 py-8 md:gap-0 md:py-4">
          <div className="w-full md:w-1/2 px-4 text-center md:px-0 md:text-left text-[#212529] service-card-67">
            <h3 className="font-bold font-sf" style={{ fontSize: "24px" }}>
              Real Time Order Tracking
            </h3>
            <p className="mx-auto mt-3 text-[16px] leading-7 font-sf text-gray-500 md:mx-0">
              Track your parcels every step of the way with Packky’s live tracking. From pickup to drop-off, both you and your customers know exactly where the delivery is, reducing confusion and improving trust.
            </p>
          </div>

          <div className="w-full md:w-1/2 text-center">
            <img
              src={Group53}
              className="h-auto max-w-full rounded"
              style={{ maxHeight: "350px" }}
              alt="Real Time Order Tracking"
            />
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-8 py-8 md:flex-row-reverse md:gap-0 md:py-4">
          <div className="w-full md:w-1/2 px-4 text-center md:px-0 md:text-left text-[#212529] service-card-67">
            <h3 className="font-bold font-sf" style={{ fontSize: "24px" }}>
              Smart Route Optimization
            </h3>
            <p className="text-base font-sf text-gray-500 mt-3 pb-7">
              Deliver faster with Packky’s advanced routing system. It automatically finds the most efficient path, helping you cut delivery time, save fuel costs, and handle multiple stops with ease.
            </p>
          </div>

        <div className="w-full md:w-1/2 flex justify-center px-4 md:px-0">
  <div className="relative inline-block">
    
    {/* Blue Background */}
    <div className="absolute inset-0 translate-x-[-25px] translate-y-[-25px] rounded-[32px] bg-[#ab7df5]"></div>

    {/* Image */}
    <img
      src={Group52}
      className="relative z-10 h-auto max-w-full rounded-[28px]"
      style={{ maxHeight: "350px" }}
      alt="Smart Route Optimization"
    />
  </div>
</div>
        </div>

        <div className="flex flex-wrap items-center gap-8 py-8 md:gap-0 md:py-4">
          <div className="w-full md:w-1/2 text-center text-[#212529] md:text-left service-card-67">
            <h3 className="font-bold font-sf" style={{ fontSize: "24px" }}>
              Driver Management
            </h3>
            <p className="text-lg font-sf text-gray-500 pb-7 mt-3">
              Easily manage your delivery fleet with real-time driver tracking and task assignment. Keep operations organized, boost driver productivity, and ensure deliveries stay on schedule.
            </p>
          </div>

           <div className="w-full md:w-1/2 flex justify-center px-4 md:px-0">
  <div className="relative inline-block">
    
    {/* Blue Background */}
    <div className="absolute inset-0 translate-x-[-25px] translate-y-[-25px] rounded-[32px] bg-[#ffc772]"></div>

    {/* Image */}
    <img
      src={Group51}
      className="relative z-10 h-auto max-w-full rounded-[28px]"
      style={{ maxHeight: "350px" }}
      alt="Smart Route Optimization"
    />
  </div>
</div>
        </div>

        <div className="flex flex-wrap items-center gap-8 py-8 md:flex-row-reverse md:gap-0 md:py-4">
          <div className="w-full md:w-1/2 text-center text-[#212529] md:text-left service-card-67">
            <h3 className="font-bold font-sf" style={{ fontSize: "24px" }}>
              Customer Notifications
            </h3>
            <p className="mx-auto mt-3 text-[16px] leading-7 font-sf text-gray-500 md:mx-0">
              Keep your customers in the loop with timely alerts about their delivery status. From dispatch to doorstep, notifications ensure clear communication and happier recipients.
            </p>
          </div>

          <div className="w-full md:w-1/2 text-center">
            <img
              src={Group54}
              className="h-auto max-w-full rounded"
              style={{ maxHeight: "350px" }}
              alt="Customer Notifications"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurService;